import { inject, injectable } from 'inversify';
import { SocketProcessingAdapter } from '@dealroadshow/file-uploader';
import type { ISocketClient } from '@allocate/socket-client';
import { SocketClient } from '@allocate/socket-client';
import { ISocketProcessingAdapter } from './DI/interfaces';

@injectable()
export class AllocateSocketProcessingAdapter extends SocketProcessingAdapter implements ISocketProcessingAdapter {
  constructor(@inject(SocketClient) socketClient: ISocketClient) {
    super(socketClient);
  }
}
